import PropTypes from 'prop-types';

import ErrorState from '@zenbusiness/zui/ErrorState';
import PageHeader from '@zenbusiness/zui/PageHeader';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';

function ErrorStateSection({ title }) {
  return (
    <Stack spacing={1.5}>
      {title ? (
        <>
          <PageHeader
            title={<Text color="primary" size="xl" weight="medium">{title}</Text>}
            paddingX={2}
            sx={{ marginBottom: 2 }}
          />
          <ErrorState />
        </>
      ) : <ErrorState />}
    </Stack>
  );
}

ErrorStateSection.propTypes = {
  title: PropTypes.string
};

export default ErrorStateSection;
